import { DEITIES, getDeity } from "../deities";
import { FESTIVALS, getFestival } from "../festivals";
import { VRATAS, getVrata } from "../vratas";
import { STORIES, getStory } from "../stories";
import { SADHANAS, getSadhana } from "../sadhanas";
import { MANTRAS, getMantra } from "../mantras";

export const SACRED_TYPES = ["deity", "festival", "vrata", "story", "sadhana", "mantra"];

const GETTERS = {
  deity: getDeity,
  festival: getFestival,
  vrata: getVrata,
  story: getStory,
  sadhana: getSadhana,
  mantra: getMantra,
};

const CATALOGS = {
  deity: DEITIES,
  festival: FESTIVALS,
  vrata: VRATAS,
  story: STORIES,
  sadhana: SADHANAS,
  mantra: MANTRAS,
};

export function getSacredEntry(type, id) {
  const fn = GETTERS[type];
  return fn ? fn(id) : null;
}

export function listSacredByType(type) {
  return CATALOGS[type] ?? [];
}

export function getAllSacredEntries() {
  return [
    ...DEITIES.map((e) => ({ type: "deity", entry: e })),
    ...FESTIVALS.map((e) => ({ type: "festival", entry: e })),
    ...VRATAS.map((e) => ({ type: "vrata", entry: e })),
    ...STORIES.map((e) => ({ type: "story", entry: e })),
    ...SADHANAS.map((e) => ({ type: "sadhana", entry: e })),
    ...MANTRAS.map((e) => ({ type: "mantra", entry: e })),
  ];
}

export function sacredPath(type, id) {
  const plural = type === "deity" ? "deities" : `${type}s`;
  return `/library/${plural}/${id}`;
}

export function beginnerSummary(type, entry) {
  if (!entry) return "";
  switch (type) {
    case "deity":
      return entry.beginner?.identity ?? entry.name;
    case "festival":
      return entry.beginner?.meaning ?? entry.name;
    case "vrata":
      return entry.beginner?.meaning ?? entry.name;
    case "story":
      return entry.beginner?.summary ?? entry.title;
    case "sadhana":
      return entry.beginner?.purpose ?? entry.name;
    case "mantra":
      return entry.beginner_summary ?? entry.text;
    default:
      return entry.name || entry.title || "";
  }
}

export function displayName(type, entry) {
  if (type === "story") return entry.title;
  return entry.name;
}

export { createEmptySacredEntry, deepLayerTemplate } from "./empty-entry";

export function editPath(type, id) {
  const plural = type === "deity" ? "deities" : `${type}s`;
  return `/library/${plural}/${id}/edit`;
}
